import { useState } from 'react';
import useSWRInfinite from 'swr/infinite';
import { jsonFetcherWithHandler as fetcher } from 'lib/swr';
import {
  CommunityUserForHire,
  CommunityUserForHireListItem,
} from 'types/community';
import UserList from './UserList';

type Props = {
  sortBy?: string;
};

function getCommunityUsersForHireUrl(
  sortBy: string = 'published',
  pageIndex?: number
) {
  const params: Record<string, string> = {
    limit: '20',
    sort_by: sortBy,
  };

  if (pageIndex) {
    params.page = pageIndex.toString();
  }

  const queryString = new URLSearchParams(params).toString();
  return `/api/community-users/for-hire?${queryString}`;
}

export default function UsersForHireView({ sortBy }: Props) {
  const [hasMoreItems, setHasMoreItems] = useState<boolean>(true);

  function getUrl(
    pageIndex: number,
    previousPageData: CommunityUserForHireListItem[] | null
  ) {
    if (pageIndex === 0) {
      return getCommunityUsersForHireUrl(sortBy);
    }

    if (previousPageData === null || previousPageData.length === 0) {
      setHasMoreItems(false);
      return null;
    }

    return getCommunityUsersForHireUrl(sortBy, pageIndex);
  }

  const itemHandler = (data: any) =>
    data.users.map((u: any) => CommunityUserForHire.fromAPI(u).toListItem());

  const { data: loadedListItems, setSize } = useSWRInfinite(
    getUrl,
    fetcher(itemHandler),
    {
      initialSize: 1,
      revalidateFirstPage: false,
    }
  );

  const onScrollNearEnd = () => setSize((size) => size + 1);

  return (
    <UserList
      listItems={loadedListItems?.flat()}
      hasMoreItems={hasMoreItems}
      onScrollNearEnd={onScrollNearEnd}
    />
  );
}
